import React from 'react'
import "./ComingSoon.css"
import { FaInstagram } from 'react-icons/fa'

const ComingSoon = () => {
  return (
    <div className='coming-soon-container'>
      <img src="./assets/offwhitery.png" alt="First Logo" className="landing-page-logo fade-up" />
      <h1 className='coming-soon-title'>Stay Tuned...</h1>
      <p className='coming-soon-description'>Your next favorite shopping destination is just around the corner—don't miss it! </p>
      <div className="landing-page-footer-icon">
        <a href="https://www.instagram.com/riymay_/profilecard/?igsh=bHdscDAxMmEyaXdx"><FaInstagram className="landing-page-insta-logo" /></a>
      </div>
    </div>
  )
}

export default ComingSoon
